import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle2() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article2" headerImage="rotor.jpg" reference="https://www.pexels.com/photo/white-windmill-851004/" photographer="Peter de Vink" />
        <Footer />
    </div>
  )
}
 